import * as THREE from 'three';
import {
  CARD1Web
} from '../CoordUtils.js';

import {BaseDrawer} from "@/drawings3D/modelDrawing/BaseDrawer"

export class GuardRailDrawer extends BaseDrawer {
  //isYK: 是否是上行车道
  constructor(guardRail, sceneManager, isYK, stepFactor){
    super(sceneManager, guardRail.startStake, guardRail.endStake, guardRail.roadStakes);
    this.guardRail = guardRail;
    this.isYK = isYK;
    this.height = this.guardRail.height;
    this.stepFactor = stepFactor;
    this.guardPoleMaterial = new THREE.MeshPhongMaterial({
      map: new THREE.TextureLoader().load("/static/bimroad/textures/guardPoleSurface.jpg")
  });
    
    
  }

  

  draw(){

        var curveLine = new Array();
        if (this.isYK){
          curveLine.push(this.rightBasePos);
          //原因同basedrawer，第一个点和第二个点同高以免shape发生旋转
          var midPt = new THREE.Vector3();
          midPt.lerpVectors(this.rightBasePos, this.roadStakes[1].a2, 0.5);
          midPt.y = this.rightBasePos.y;
          curveLine.push(midPt);
          for(var i = 1; i < this.roadStakes.length - 1; i++){
            curveLine.push(this.roadStakes[i].a2);
          }
          curveLine.push(this.rightEndBasePos);
        }
        else{
          
          curveLine.push(this.leftBasePos);
          var midPt = new THREE.Vector3();
          midPt.lerpVectors(this.leftBasePos, this.roadStakes[1].a1, 0.5);
          midPt.y = this.leftBasePos.y;
          curveLine.push(midPt);
          for(var i = 1; i < this.roadStakes.length - 1; i++){
            curveLine.push(this.roadStakes[i].a1);
          }
          curveLine.push(this.leftEndBasePos);
        }

        if (curveLine.length==0) return;
        var spline = new THREE.CatmullRomCurve3(curveLine);

        spline.curveType = 'catmullrom';
        spline.closed = false;

        var extrudeSettings = {
          steps: this.lastStakeIndex * this.stepFactor,
          bevelEnabled: false,
          extrudePath: spline
        };

        //在起点构建shape
        var pts = [];
        pts.push(new THREE.Vector2(-this.guardRail.height, 0));
        pts.push(new THREE.Vector2(-this.guardRail.height - 0.1, -0.2));
        pts.push(new THREE.Vector2(-this.guardRail.height - 0.2, -0.2));
        pts.push(new THREE.Vector2(-this.guardRail.height - 0.3, 0));
        pts.push(new THREE.Vector2(-this.guardRail.height - 0.4, 0));
        pts.push(new THREE.Vector2(-this.guardRail.height - 0.5, -0.2));
        pts.push(new THREE.Vector2(-this.guardRail.height - 0.6, -0.2));
        pts.push(new THREE.Vector2(-this.guardRail.height - 0.7, 0));

        pts.push(new THREE.Vector2(-this.guardRail.height - 0.6, 0.2));
        pts.push(new THREE.Vector2(-this.guardRail.height - 0.5, 0.2));
        pts.push(new THREE.Vector2(-this.guardRail.height - 0.4, 0));
        pts.push(new THREE.Vector2(-this.guardRail.height - 0.3, 0));
        pts.push(new THREE.Vector2(-this.guardRail.height - 0.2, 0.2));
        pts.push(new THREE.Vector2(-this.guardRail.height - 0.1, 0.2));

        var shape = new THREE.Shape( pts);
        var guradRailGeometry = new THREE.ExtrudeGeometry( shape, extrudeSettings );
        
        var guradRailMesh = new THREE.Mesh( guradRailGeometry, this.medialDividerMaterial);
        guradRailMesh.updateMatrix();
        this.geometry.merge(guradRailMesh.geometry, guradRailMesh.matrix);
        
        var _this = this;
        var stakeHeight = _this.height + 0.7;

        //波板桩
        for(var i = 0; i < curveLine.length; i++){
          if (i==1) continue; //第二个点是插值的，避免shape旋转
          var item = curveLine[i];
          var stakeGeometry = new THREE.CylinderGeometry( 0.2, 0.2, stakeHeight, 5);
          var stakeMesh = new THREE.Mesh( stakeGeometry, this.guardPoleMaterial);
          stakeMesh.position.copy(new THREE.Vector3(item.x, item.y + stakeHeight / 2, item.z));
           stakeMesh.updateMatrix();
          this.geometry.merge(stakeMesh.geometry, stakeMesh.matrix);
        }

        return new THREE.Mesh(this.geometry, this.guardPoleMaterial);
  }
 
}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/GuardRailDrawer.js